export default __webpack_public_path__ + "static/media/table_white.2fe2488a.svg";